__turbopack_context__.v({
  "service": "ServiceElement-module-scss-module__yQbN7G__service",
  "service__icon": "ServiceElement-module-scss-module__yQbN7G__service__icon",
  "service__title": "ServiceElement-module-scss-module__yQbN7G__service__title",
});
